import React, {Component} from 'react'
import {DatePicker} from 'antd'

import style from './datePicker.sass'

class Wrapper extends Component {
  render() {
    const {value, handleChange, disabledDate} = this.props
    return(
      <DatePicker
        styleName='wrapper'
        format='M/D/YYYY'
        allowClear={false}
        disabledDate={disabledDate}
        onChange={handleChange}
        value={value}
      />
    )
  }
}

export default Wrapper
